import { z } from "zod";

export const ObrasMateriaisControladosSchema = z.object({
  idMateriaisControlados: z
    .array(z.number(), { required_error: "Este campo deve ser preenchido!" })
    .nonempty("Este campo deve ser preenchido!"),
});

export type ObrasMateriaisControladosForm = z.infer<typeof ObrasMateriaisControladosSchema>;
